import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';

import { Loader } from 'components/Loader/Loader';
import type { AppDispatch } from 'kb-redux';
import { LOG_OUT, logoutPatient } from 'kb-redux/user.redux';
import { MAINTENANCE_QUERY_PARAM } from 'utilities/constants';
import { pageUrl } from 'utilities/pageUrl';
import { getPostLogoutLandingUrl } from 'utilities/userUtil';

interface LocationState {
  redirectToPasswordReset?: boolean;
  email?: string;
  passwordResetFlow?: 'change-password';
}

export const Logout = () => {
  const location = useLocation();
  const locationState = location?.state as LocationState;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const clearAuthSessionAndRedirect = useCallback(async () => {
    const postLogoutLandingUrl = getPostLogoutLandingUrl();
    dispatch({ type: LOG_OUT });
    await logoutPatient();
    redirectPatient(postLogoutLandingUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    clearAuthSessionAndRedirect();
  }, [clearAuthSessionAndRedirect]);

  const redirectPatient = (postLogoutLandingUrl: string) => {
    let redirectUrl = '';

    if (location.search.match(/login/) || location.search.match(/logout/)) {
      redirectUrl = pageUrl.login();
    } else if (locationState?.redirectToPasswordReset) {
      redirectUrl = pageUrl.passwordReset({
        email: locationState?.email,
        flow: locationState?.passwordResetFlow
      });
    } else {
      redirectUrl = `${pageUrl.login()}${location.search}`;
      if (redirectUrl.includes('target=')) redirectUrl = `${redirectUrl}&loggedOut=1`;
    }

    const params = new URLSearchParams(location.search);
    const isMaintenanceMode = params.get(MAINTENANCE_QUERY_PARAM) === 'true';

    if (postLogoutLandingUrl && !locationState?.redirectToPasswordReset && !isMaintenanceMode) {
      window.location.href = postLogoutLandingUrl;
    } else {
      navigate(redirectUrl, { replace: true });
    }
  };

  return <Loader absoluteCentered />;
};
